import _ from 'lodash';
import { Roles } from '../enums';
import { useAppSelector } from './storeHooks';

const useCheckAuthorization = () => {
  const { user } = useAppSelector((store) => ({
    user: store.user,
  }));

  return (
    !_.isNil(user.data) &&
    !_.isNil(_.find(user.data.roles, (x) => x === Roles.SUPER_ADMIN))
  );
};

export default useCheckAuthorization;
